export class ContactForm {

    email: string;

    subject: string;

    text: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/index/contact-form.ts